module.exports = __webpack_public_path__ + "static/img/apply2.414baf0.png";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/apply2.png
// module id = CI6P
// module chunks = 0